import { gql, useQuery } from "@apollo/client";
import { obeliskClient } from "./obelisk";
import { urlPillars } from "../hooks/urlConfigs";
import configs from "../config/app";
import { cacheGet } from "../util/cache";
import { GetToken } from "../features/authentication/hooks/useToken";

class pillarsClient extends obeliskClient
{
    constructor() {
        super();
        this.version = configs.pillarsVersion;
        this.baseUrl = configs.pillarsApi;
        this.init();
        this.headers = {};
        const token = GetToken()?.token;
        this.setHeader("Authorization", `Bearer ${token || ""}`);
        this.setHeader("Content-Type", "application/json");
        this.setHeader("Accept", "application/json");
    }
    /**
     * @param {string} keyName
     * @returns {string}
     */
    getCallByType(keyName) {
        const path = urlPillars[keyName] ?? null;
        return `/api/v${this.version}/${path || keyName}`;
    }
    /**
     * @param {string} qString - GraphQL query string
     * @param {Record<string, any>} [bind] - Variables to bind to the query
     * @returns {QueryResult<any, Record<string, any>>}
     */
    graph(qString, bind = {}) {
        if(!qString)
            throw new Error('GraphQL query string is required');
        const q = gql(`${qString}`);
        return useQuery(q, {
          variables: { ...bind },
        });
    }

}

const pillars = () => new pillarsClient();
export default pillars;